export default (data) => {
  const ids = [];

  Object.values(data).forEach((d) => {
    ids.push(d.id);
  });

  return ['match', ['get', 'id'], ids, false, true];
};
